// Check if Mapbox should be used
function useMapbox() {
  // Check data attribute first (set by view template)
  const mapContainer = document.getElementById('pages-directories-show-map');
  if (mapContainer && mapContainer.dataset.useMapbox === 'true') {
    return true;
  }
  // Fallback to global config (if set via window)
  return window.mapsConfig?.provider === 'mapbox' || false;
}

// Get the appropriate manager
function getMapsManager() {
  return useMapbox() ? window.mapboxManager : window.googleMapsManager;
}

// Get the API key/access token
function getMapsCredential(container) {
  return useMapbox() 
    ? container.dataset.accessToken 
    : container.dataset.apiKey;
}

document.addEventListener('turbo:load', function(e) {
  const mapContainer = document.getElementById('pages-directories-show-map');
  if (!mapContainer) return;

  const manager = getMapsManager();
  if (!manager) {
    console.error('Maps Manager not available');
    mapContainer.innerHTML = '<div class="flex items-center justify-center h-full text-gray-500">Maps Manager not loaded</div>';
    return;
  }

  // Directories map is often below the fold, use lazy loading
  const mapOptions = prepareDirectoriesMapOptions(mapContainer);
  if (!mapOptions) return;

  manager.registerLazyMap(
    mapContainer,
    mapOptions,
    'directories-show-map',
    (map) => {
      setupDirectoriesMapMarkers(map, mapContainer);
    }
  );
});

/* --------------------------------------------------
                Prepare Directories Map Options
-------------------------------------------------- */
function prepareDirectoriesMapOptions(container) {
  const useMapboxProvider = useMapbox();
  const zoom = parseInt(container.getAttribute('data-zoom'));

  // Check if directoryOfficesData is available
  if (typeof directoryOfficesData === 'undefined') {
    console.warn('directoryOfficesData not available');
    return null;
  }

  const firstOfficeWithLocation = directoryOfficesData.find(office => office.latitude && office.longitude);
  if (!firstOfficeWithLocation) {
    console.warn('No offices with location data found');
    return null;
  }

  if (useMapboxProvider) {
    return {
      style: 'mapbox://styles/mapbox/light-v11', // Light style similar to grayscale Google Maps
      center: [parseFloat(firstOfficeWithLocation.longitude), parseFloat(firstOfficeWithLocation.latitude)],
      zoom: zoom
    };
  } else {
    return {
      zoom: zoom,
      mapTypeControl: false,
      center: {
        lat: firstOfficeWithLocation.latitude,
        lng: firstOfficeWithLocation.longitude
      },
      styles: [
        {
          stylers: [
            { saturation: -100 }
          ]
        }
      ]
    };
  }
}

/* --------------------------------------------------
                Setup Directories Map Markers
-------------------------------------------------- */
function setupDirectoriesMapMarkers(map, container) {
  const useMapboxProvider = useMapbox();
  const manager = getMapsManager();

  // Check if directoryOfficesData is available
  if (typeof directoryOfficesData === 'undefined') {
    console.warn('directoryOfficesData not available');
    return;
  }

  if (useMapboxProvider) {
    setupMapboxDirectoriesMarkers(map, container, manager);
  } else {
    setupGoogleDirectoriesMarkers(map, container);
  }
}

/* --------------------------------------------------
                Setup Google Maps Directories Markers
-------------------------------------------------- */
function setupGoogleDirectoriesMarkers(map, container) {
  const markers = [];

  for (const office of directoryOfficesData) {
    if (office.latitude && office.longitude) {
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(office.latitude, office.longitude),
        map: map,
        icon: {
          url: '/map-pin.png?v=' + new Date().getTime(),
          scaledSize: new google.maps.Size(32, 32),
        }
      });
      markers.push(marker);
    }
  }

  // Update the registered map with markers
  const existingMapData = window.googleMapsManager.activeMaps.get('directories-show-map');
  if (existingMapData) {
    existingMapData.markers = markers;
  }
}

/* --------------------------------------------------
                Setup Mapbox Directories Markers
-------------------------------------------------- */
function setupMapboxDirectoriesMarkers(map, container, manager) {
  // Wait for map to load before adding markers
  map.on('load', () => {
    const markers = [];

    for (const office of directoryOfficesData) {
      if (office.latitude && office.longitude) {
        // Create marker element with pin icon
        const el = document.createElement('div');
        el.className = 'mapbox-marker';
        el.style.width = '32px';
        el.style.height = '32px';
        el.style.cursor = 'pointer';
        
        // Create pin image
        const img = document.createElement('img');
        img.src = '/map-pin.png';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.display = 'block';
        img.alt = office.name || 'Office location';
        el.appendChild(img);

        // Create marker with anchor at bottom center (pin point)
        const marker = manager.createMarker({
          element: el,
          anchor: 'bottom' // Pin tip should be at the location
        });

        marker.setLngLat([parseFloat(office.longitude), parseFloat(office.latitude)]);
        marker.addTo(map);
        markers.push(marker);
      }
    }

    // Update the registered map with markers
    const existingMapData = manager.activeMaps.get('directories-show-map');
    if (existingMapData) {
      existingMapData.markers = markers;
    }
  });
}
